module.exports = __webpack_public_path__ + "static/media/UPS-Campiaign-Terms-Conditions.4b4e3dab.pdf";